export * as entityMapper from '@wix/auto_sdk_multilingual_entity-mapper/meta';
export * as locales from '@wix/auto_sdk_multilingual_locales/meta';
export * as translationPublishedContents from '@wix/auto_sdk_multilingual_translation-published-contents/meta';
export * as translationCredits from '@wix/auto_sdk_multilingual_translation-credits/meta';
export * as machineTranslation from '@wix/auto_sdk_multilingual_machine-translation/meta';
export * as localeSettings from '@wix/auto_sdk_multilingual_locale-settings/meta';
export * as siteTranslator from '@wix/auto_sdk_multilingual_site-translator/meta';
export * as translationContents from '@wix/auto_sdk_multilingual_translation-contents/meta';
export * as translationSchemas from '@wix/auto_sdk_multilingual_translation-schemas/meta';
